<template>
    <div id="top-content-container">
        <transition name="fade" mode="out-in">
            <router-view :key="$route.path"></router-view>
        </transition>
    </div>
</template>

<script>
export default {
    name: "contentcontainer",
    computed: {},
    data() {
        return {}
    },
    components: {},
    methods: {}
}
</script>

<style>
#top-content-container {
    /* height: calc( 100% - 60px ); */
    /* min-height: calc(100% - 60px); */
    min-height: calc(100% - 350px);
    width: 100%;
    /* background:orange; */
    width: auto;
    margin-left: 15%;
    margin-right: 15%;
    padding-top: 20px;
    background-color: rgb(255, 255, 255);    
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0
}

@media (max-width: 900px) {
    #top-content-container {
        margin-left: 4%;
        margin-right: 4%;
    }
}
</style>



